import React, { useEffect, useRef, useState } from 'react';
import { Params, useNavigate, useParams } from 'react-router-dom';
import { Card, Modal } from '@sede-enterprise/shell-ds-react-framework';
import { useToast } from 'rc-toastr';
import { Col, Row } from '../../components/flexbox/Flex';
import { ContainerDiv } from '../../components/styledComponent/StyledComponent';
import BackButton from '../../components/backButton/BackButton';
import TicketForm from '../../components/ticketForm/TicketForm';
import { ApiUrls } from '../../helpers/ApiUrls';
import { getData, postData, postDataFile } from '../../services/ApiService';
import ResponseErrorModal from '../../components/responseErrorModal/ResponseErrorModal';
import { usePageTitle } from '../../services/UtilService';
import Loader from '../../components/loader/Loader';
import { Constants } from '../../helpers/Constants';
import { APIErrorResponseInterface } from '../../helpers/InterfacesConstants';
import { useTranslation } from 'react-i18next';


interface formData{

    suppliedCustomerName?: string,
    suppliedCustomerCode?: string,
    suppliedAircraftRegistration?: string,
    suppliedCardNumber?: string,
    suppliedConco?: string,
    suppliedCreditType?: string,
    suppliedCustomerAccountNumber?: string,
    suppliedDelco?: string,
    suppliedDutyInd?: string,
    suppliedExternalInd?: string,
    suppliedFinalDestination?: string,
    suppliedFlightId?: string,
    suppliedNextDestination?: string,
    suppliedPackType?: string,
    suppliedVATInd?: string,

    confirmedCustomerName? : string ,
    confirmedCustomerCode? : string,
    confirmedCreditType? : string,
    confirmedConco? : string,
    confirmedDelco? : string,
    confirmedCustomerAccountNumber?: string,
    confirmedCardNumber? : string,
    confirmedVATInd? : string,
    confirmedDutyInd? : string,
    confirmedExternalInd? : string,
    confirmedPackType? : string,
    confirmedAircraftRegistration? : string,
    confirmedFlightId? : string,
    confirmedNextDestination? : string,
    confirmedFinalDestination? : string,
    comments? : string,
    filename?:File | null,
    nextDestinationResults?: {confirmedNextDestination: string, suppliedNextDestination: string}[],
    version?: string,
    ticketNumber? : string
};

const CorrectTicket = () => {
    const transaction = useParams();
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const [ transactionData, setTransactionData] = useState<formData>({});
    const [apiErrorResponse, setApiErrorResponse] = useState<APIErrorResponseInterface | null>();

    const [creditTypes, setCreditTypes] = useState<{code:string, desc:string}[]>([]);
    const [cardNumbers, setCardNumbers] = useState<string[]>([]);
    const [customerAccountNumbers, setCustomerAccountNumbers] = useState<string[]>([]);
    const [ customers, setCustomers ] = useState<{customerId: string, CustomerCode: string, customerName: string}[]>([]);

    const dataFetchedRef = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const { toast } = useToast();

    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const { t } = useTranslation();
    usePageTitle(t('shellAviationAIMS')+" | Correction");
    
    const getDetails = (transaction: Readonly<Params<string>>) =>{
        const url = ApiUrls.editDetails + transaction.headerId
        getData(url).then((response) => {
            setTransactionData(response.data.ticketEditFieldResult);
            setCardNumbers(response.data.customerCardDetail);
            setCustomerAccountNumbers(response.data.customerAccountNumber);
            setCreditTypes(response.data.creditTypes);
            setCustomers(response.data.editCustomerResults);
            setIsLoading(false);
        }).catch((error) => {
            setApiErrorResponse({
                message : error.response.data.message,
                traceId : error.response.data.traceId
            });
        });
    }

    const getRequestObject = () =>{
        const tempNextDestinations: {type: string, value: string}[] = [];

        transactionData.nextDestinationResults && transactionData.nextDestinationResults.map((nextDestination:{confirmedNextDestination: string, suppliedNextDestination: string}, index:number) => (
            tempNextDestinations.push({type: 'NDT'+(index+1) , value: nextDestination.confirmedNextDestination})
        ));
        return {
            "isSubmit": false,
            "isCorrection": true,
            "customerName": transactionData && transactionData.confirmedCustomerName,
            "customerCode": transactionData && transactionData.confirmedCustomerCode,
            "creditType": transactionData && transactionData.confirmedCreditType,
            "conco": transactionData && transactionData.confirmedConco,
            "delco": transactionData && transactionData.confirmedDelco,
            "customerAccountNumber": transactionData && transactionData.confirmedCustomerAccountNumber,
            "customerCardNumber": transactionData && transactionData.confirmedCardNumber,
            "vatInd": transactionData && transactionData.confirmedVATInd,
            "dutyInd": transactionData && transactionData.confirmedDutyInd,
            "externalInd": transactionData && transactionData.confirmedExternalInd,
            "packType": transactionData && transactionData.confirmedPackType,
            "aircraftRegistration": transactionData && transactionData.confirmedAircraftRegistration,
            "flightId": transactionData && transactionData.confirmedFlightId,
            "nextDestinations": tempNextDestinations,
            "nextDestination": transactionData && transactionData.confirmedNextDestination,
            "finalDestination": transactionData && transactionData.confirmedFinalDestination,
            "modifiedBy": '',
            "modifiedDate":'',
            "version": transactionData.version

        };
    } 

    const getFileObject = () => {
        return {
            "reason" : transactionData && transactionData.comments,
            "file": transactionData && transactionData.filename
        };
    }

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
		getDetails(transaction);
	},[]);

    const cancel = () =>{
        navigate("/rawdata/");
    }


    const submitSuccessCallback = () => {
        setOpen(false);
        toast.success("Submitted Successfully");
        navigate("/rawdata/");
    }
    const submit = () =>{
        const requestObj = getRequestObject();
        const url = ApiUrls.updateTransaction +  transaction.headerId;
        setOpen(true);
        postData(url, requestObj).then((response)=>{
            const requestFileObject = getFileObject();
            if(requestFileObject.file || requestFileObject.reason){
                const uploadURL = ApiUrls.updateTransFileUpload +  transaction.headerId;
                postDataFile(uploadURL, requestFileObject).then((response)=>{
                    submitSuccessCallback();
                }).catch((error)=>{
                    setOpen(false);
                    setApiErrorResponse({
                        message : error.response.data.message,
                        traceId : error.response.data.traceId
                    });
                });
            }else{
                submitSuccessCallback();
            }
        }).catch((error)=>{
            setApiErrorResponse({
                message : error.response.data.message,
                traceId : error.response.data.traceId
            });
        });
    }

    const updateState = (obj: any) => {
        setTransactionData(obj);
    }

    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(e.target.files){
            const fileList : FileList = e.target.files;
            const filesArray = Array.from(fileList) as File[];
            
            // Validate file types
            const invalidFiles = filesArray.filter(
                (file) =>
                !['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
                'application/vnd.ms-outlook', 
                'application/vnd.ms-excel',
                'application/pdf',
                'image/jpeg'].includes(
                    file.type
                )
            );
        
            if (invalidFiles.length > 0) {
                alert('Invalid file type. Please select valid files.');
                return;
            }

            const oversizedFiles = filesArray.filter(file => file.size > Constants.maxFileSizeInBytes);

            if (oversizedFiles.length > 0) {
                alert(`File size should be less than 1 MB. Please select valid files.`);
                return;
            }
            setSelectedFiles(filesArray);
            setTransactionData({...transactionData, "filename": fileList[0]});
        }
    };

    const handleCancel = () => {
        // Clear selected files
        setSelectedFiles([]);
        setTransactionData({...transactionData, "filename": null});
    };

    return(
        <>
            <ContainerDiv>
                <Row>
                    <Col> 
                        <BackButton/>
                    </Col>
                </Row>
                <Row>
                    <Col size="100"> 
                        <h2 style={{margin:'0px'}}>Create Correction</h2>
                    </Col>
                </Row>
            </ContainerDiv>

            <ContainerDiv>    
                <Card> 
                    <Row>
                        <Col size="100">
                            <h3>Ticket # {transactionData.ticketNumber} </h3>
                        </Col>
                    </Row>
                    
                    <hr style={{width:'100%'}}/>
                    {isLoading && <Loader/>}
                    <TicketForm transactionData={transactionData} onCancel={cancel} onSubmit={submit} onChange={updateState} creditTypes={creditTypes} cardNumbers={cardNumbers} customerAccountNumbers={customerAccountNumbers} customers={customers} handleFileUpload={handleFileUpload} selectedFiles={selectedFiles} onFileCancel={handleCancel}/>
                </Card>
                
            </ContainerDiv>

            <Modal loading={true} loadingBody="Submitting your ticket... please wait." closable={false} open={open} onClose={() => {setOpen(false);}} />
            <ResponseErrorModal errorDetails={apiErrorResponse} isOpen={apiErrorResponse? true : false} onModalClose={()=>{setApiErrorResponse(null)}}/>
        </>
    )
}
export default CorrectTicket;